import { FormattedMessage } from 'react-intl';

interface IProps {
  onClose?: () => void;
  onClick?: () => void;
}

const BackModal = ({ onClose, onClick }: IProps) => {
  return (
    <div className="fixed inset-0 w-full h-full bg-[rgba(0,0,0,0.8)] flex justify-center items-center z-[1000]">
      <div className="min-w-[570px] px-[40px] pt-[48px] pb-[40px] rounded-[20px] bg-white text-center">
        <h3 className="text-[30px] leading-9 font-extrabold">
          <FormattedMessage id="info_modal_title" defaultMessage="Are you sure you want to leave?" />
        </h3>
        <p className="mt-5 mb-[42px] text-[20px] leading-7 font-medium text-[#4D4D4D]">
          <FormattedMessage id="info_modal_desc1" defaultMessage="You might lose any changes" />
          <br />
          <FormattedMessage id="info_modal_desc2" defaultMessage="you've made on this page." />
        </p>
        <div className="flex gap-[12px]">
          <button
            className="flex-1 flex justify-center items-center h-[66px] rounded-[20px] bg-[#f2f2f2] text-[18px] leading-9 font-bold data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white"
            onClick={() => onClick?.()}
          >
            <FormattedMessage id="info_modal_leave" defaultMessage="Leave" />
          </button>
          <button
            className="flex-1 flex justify-center items-center h-[66px] rounded-[20px] bg-[#f5f5f5] text-[18px] leading-9 font-bold data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white"
            data-primary
            onClick={() => onClose?.()}
          >
            <FormattedMessage id="info_modal_stay" defaultMessage="Stay" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackModal;
